import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Description as DescriptionIcon } from "@material-ui/icons";
import { Form, Formik } from "formik";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useIntl } from "react-intl";
import * as yup from "yup";
import { LoginLayout } from "../components";
import { CheckboxField, SubmitButton } from "../components/formik";
import PdfDialog from "../components/PdfDialog";
import PoliciesViewer from "../components/PoliciesViewer";
import { updateProfile } from "../ducks/actions";
import { useActionRequest, useCongress } from "../hooks";

const useStyles = makeStyles(() => ({
  form: {
    textAlign: "center"
  }
}));

const TermsPage = () => {
  const intl = useIntl();
  const classes = useStyles();

  const { congress } = useCongress();
  const [selectedPdf, setSelectedPdf] = useState();

  const policiesViewerRef = useRef({ current: {} });

  const updateProfileRequest = useActionRequest({
    action: updateProfile,
    redirect: "/"
  });

  const onSubmit = profile => {
    /* eslint-disable no-param-reassign */
    if (profile.termsAcceptance) profile.termsAcceptance = moment().format();
    updateProfileRequest({ profile });
  };

  return (
    <LoginLayout>
      <Typography variant="h5">
        {intl.formatMessage({
          id: "Pages.TermsPage.Title",
          defaultMessage: "Terms & Conditions"
        })}
      </Typography>
      <br />
      <Typography variant="body1">
        {intl.formatMessage({
          id: "Pages.TermsPage.Description",
          defaultMessage:
            "Before continue you must read and agree the following terms and conditions documents:"
        })}
      </Typography>
      <List>
        {congress.additionalTermsDocuments.map(additionalTermsDocument => {
          return (
            <ListItem
              button
              key={additionalTermsDocument.label}
              onClick={() => setSelectedPdf(additionalTermsDocument)}
            >
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText primary={additionalTermsDocument.label} />
            </ListItem>
          );
        })}
        <ListItem button onClick={() => policiesViewerRef.current.setOpenPrivacyPolicy(true)}>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary="Privacy Policy" />
        </ListItem>
        <ListItem button onClick={() => policiesViewerRef.current.setOpenCookiePolicy(true)}>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary="Cookie Policy" />
        </ListItem>
      </List>

      <Formik
        initialValues={{ termsAcceptance: false }}
        validationSchema={yup.object().shape({
          termsAcceptance: yup.bool().oneOf([true], "Accept Terms & Conditions is required")
        })}
        onSubmit={onSubmit}
      >
        <Form className={classes.form}>
          <CheckboxField
            name="termsAcceptance"
            label={intl.formatMessage({
              id: "Page.TermsPage.TermsAcceptance",
              defaultMessage: "I have read and accept all terms and conditions"
            })}
            color="primary"
          />
          <br />
          <SubmitButton color="primary" variant="outlined" size="large">
            {intl.formatMessage({ id: "Page.TermsPage.Sumbit", defaultMessage: "Continue" })}
          </SubmitButton>
        </Form>
      </Formik>

      {selectedPdf && (
        <PdfDialog
          document={selectedPdf}
          title={selectedPdf.label}
          onClose={() => {
            setSelectedPdf(null);
          }}
        />
      )}

      <PoliciesViewer policiesViewerRef={policiesViewerRef} />
    </LoginLayout>
  );
};
export default TermsPage;
